import React, { useEffect, useMemo, useState } from "react";
import { useCartStore } from "../store/useCartStore";
import { useNavigate } from "react-router-dom";
import { createTranslator, useLanguage } from '../i18n/LanguageContext';
import { shopTranslations } from '../i18n/translations';

const CartDrawer = () => {
  const { language } = useLanguage();
  const t = createTranslator(language, shopTranslations);
  const isCartOpen = useCartStore((s) => s.isCartOpen);
  const closeCart = useCartStore((s) => s.closeCart);
  const cartItems = useCartStore((s) => s.cartItems);
  const removeItem = useCartStore((s) => s.removeItem);

  const [promoCode, setPromoCode] = useState("");
  const [discount, setDiscount] = useState(0);

  const navigate = useNavigate();

  const subtotal = useMemo(
    () => cartItems.reduce((sum, item) => sum + item.price * item.quantity, 0),
    [cartItems]
  );

  const total = useMemo(() => {
    if (discount > 0) return subtotal * (1 - discount / 100);
    return subtotal;
  }, [subtotal, discount]);

  useEffect(() => {
    const code = promoCode.trim().toLowerCase();
    if (code === "padel10") setDiscount(10);
    else if (code === "mendyx20") setDiscount(20);
    else setDiscount(0);
  }, [promoCode]);

  const handleCheckout = () => {
    closeCart();              // ✅ ferme explicitement (pas de toggle)
    navigate("/checkout");
  };

  return (
    <div
      className={`fixed top-0 right-0 h-full w-80 bg-white shadow-lg transform transition-transform z-[9999] ${
        isCartOpen ? "translate-x-0" : "translate-x-full"
      }`}
      style={{ pointerEvents: "auto" }}
    >
      <div className="p-4 border-b flex justify-between items-center">
        <h2 className="text-lg font-semibold text-[#4c2f8e]">{t('cart')}</h2>
        <button type="button" onClick={closeCart} aria-label={t('close')}>
          ✕
        </button>
      </div>

      <div className="p-4 space-y-4">
        {cartItems.length === 0 ? (
          <p className="text-gray-500">{t('emptyCart')}</p>
        ) : (
          cartItems.map((item) => (
            <div key={item.id} className="flex items-center gap-4 border-b pb-3">
              <img src={item.image} alt={item.name} className="w-16 h-16 object-cover rounded" />

              <div className="flex-1">
                <p className="font-medium text-[#4c2f8e]">{item.name}</p>
                {item.selectedSize && (
                  <p className="text-sm text-gray-500">{t('size')} : {item.selectedSize}</p>
                )}
                <p className="text-sm text-gray-500">
                  {item.quantity} × {item.price} €
                </p>
              </div>

              <button type="button" onClick={() => removeItem(item.id)} className="text-red-500" aria-label={t('remove')}>
                🗑
              </button>
            </div>
          ))
        )}

        {cartItems.length > 0 && (
          <div className="space-y-4 pt-4 border-t">
            {/* (optionnel) champ promo si tu le veux */}
            {/* 
            <input
              value={promoCode}
              onChange={(e) => setPromoCode(e.target.value)}
              placeholder="Code promo"
              className="w-full border rounded px-3 py-2"
            />
            */}

            <p className="font-semibold text-[#4c2f8e] text-lg">{t('total')} : {total.toFixed(2)} €</p>

            <button
              type="button"
              onClick={handleCheckout}
              className="w-full px-4 py-2 bg-gradient-to-r from-[#4c2f8e] to-[#ea4c89] text-white rounded-full hover:shadow-lg transition"
            >
              {t('continue')}
            </button>

            <p className="text-xs text-center text-gray-500 mt-2">
              {t('validating')}{" "}
              <a
                href="/terms-of-sale"
                target="_blank"
                rel="noopener noreferrer"
                className="text-[#4c2f8e] underline hover:text-[#ea4c89] transition"
              >
                {t('terms')}
              </a>
              .
            </p>
          </div>
        )}
      </div>
    </div>
  );
};

export default CartDrawer;
